import { store as createStore } from '@risingstack/react-easy-state'
import api from '../api'

/**
 * [Store]
 */
const store = createStore({
  infos: null,
  infosToSend: null,
  refreshing: false,
  refreshInfos,
  sendInfos,
  changeUsageAvanceImmediate
})

async function refreshInfos () {
  store.refreshing = true
  await api.avanceImmediate.getInfos().then((infosAvanceImmediate) => {
    store.refreshing = false
    store.infos = { ...infosAvanceImmediate }
  }).catch(() => {
    store.refreshing = false
  })
}

async function sendInfos (infos) {
  store.refreshing = true
  return api.avanceImmediate.sendInfos(infos).then((infosAvanceImmediate) => {
    store.refreshing = false
    store.infos = { ...infosAvanceImmediate }
  }).catch((e) => {
    store.refreshing = false
    throw e
  })
}

async function changeUsageAvanceImmediate (enable) {
  store.refreshing = true
  api.avanceImmediate.changeUsageAvanceImmediate(enable).then((infosAvanceImmediate) => {
    store.refreshing = false
    store.infos = { ...infosAvanceImmediate }
  }).catch((e) => {
    store.refreshing = false
    if (e.response.data.error === 'NO_AVANCE_IMMEDIATE_WITH_MANDATE') {
      window.alert('Vous ne devez pas avoir de mandat de prélèvement en cours pour pouvoir activer l\'avance immédiate')
    }
  })
}

export default store



// WEBPACK FOOTER //
// ./src/stores/avanceImmediate.js